import Table from "react-bootstrap/Table";
import _ from "lodash";
import * as reportSelectors from "../../../../selectors/report";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import EmptyItemView from "../../../../components/EmptyItemView";
function ReportSummaryTable({ data, loading }) {
  return (
    <Table responsive="xxl">
      {!loading && !_.isEmpty(data) ? (
        <thead>
        <tr className={"custom-table-setoff-styled"}>
            <th style={{minWidth: "370px", maxWidth: "370px"}}>Type</th>
            <th style={{minWidth: "140px", maxWidth: "140px"}}>Stock Count</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Quantity</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Price</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Gross Amount</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Brokerage Amount</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Exchange Rate</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Foreign Charges</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Clearing Fee</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Stamp Duty</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>SST Amount</th>
            <th style={{minWidth: "120px", maxWidth: "120px"}}>Net Amount</th>
        </tr>
        </thead>
      ) : (
          false
      )}
        <tbody>
        {!_.isEmpty(data) && !loading ? (
          _.map(data, (item) => {
            const type = reportSelectors.getReportType(item);
            const stockCount = reportSelectors.getReportStockCount(item);
            const transactionQuantity = reportSelectors.getReportTransactionQuantity(item);
            const grossAmount = reportSelectors.getReportGrossAmount(item);
            const brokerageAmount = reportSelectors.getReportBrokerageAmount(item);
            const foreignCharges = reportSelectors.getReportForeignCharges(item);
            const stampDuty = reportSelectors.getReportStampDuty(item);
            const clearingFee = reportSelectors.getReportClearingFee(item);
            const sstAmount = reportSelectors.getReportSSTAmount(item);
            const netAmount = reportSelectors.getReportNetAmount(item);
            return (
                <tr>
                    <td style={{minWidth: "370px", maxWidth: "370px"}}>{type}</td>
                    <td style={{minWidth: "140px", maxWidth: "140px"}}>{stockCount}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{transactionQuantity}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>-</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{grossAmount}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{brokerageAmount}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>-</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{foreignCharges}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{clearingFee}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{stampDuty}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{sstAmount}</td>
                    <td style={{minWidth: "120px", maxWidth: "120px"}}>{netAmount}</td>
                </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={12}>
              <EmptyItemView />
              <LoadingOverlay loading={loading}></LoadingOverlay>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

export default ReportSummaryTable;
